module.exports = __webpack_public_path__ + "static/home-99d51b524dea1bf64ae3a0669a609052.jpg";